import { Observable } from "rxjs/Observable";
import { merge } from "rxjs/observable/merge";
import { whenConnected } from "../helpers/subscription";
import { StompActionskeys } from "../stomp-broker";
import { panelRefStatusDuck } from "./operationalPanels";
export var updateOperationalStatusActions;
(function (updateOperationalStatusActions) {
    updateOperationalStatusActions["UPDATE_ON_CHANGE"] = "PANEL_REF_STATUS/UPDATE_ON_CHANGE";
    updateOperationalStatusActions["NOUPDATE_ON_CHANGE"] = "PANEL_REF_STATUS/NOUPDATE_ON_CHANGE";
})(updateOperationalStatusActions || (updateOperationalStatusActions = {}));
export const subscribeToRefStatusUpdate = (config) => ({
    payload: config,
    type: updateOperationalStatusActions.UPDATE_ON_CHANGE,
});
export const unSubscribeRefStatusUpdate = () => ({
    type: updateOperationalStatusActions.NOUPDATE_ON_CHANGE,
});
export const createSubscriptionRefEpic = (actions$, _, { stomp }) => {
    return whenConnected(actions$, updateOperationalStatusActions.UPDATE_ON_CHANGE).mergeMap(([_value, action]) => {
        return stomp
            .subscribe("/user/topic/focus/dataset/refStatus")
            .filter((res) => res.type === "DATASET_REF_STATUS")
            .filter((res) => res.payload.id === action.payload.subscriptionPaths.data)
            .mergeMap((res) => {
            return Observable.of(panelRefStatusDuck.actions.setItem(action.payload, res.payload.refStatus));
        })
            .catch(() => Observable.empty())
            .takeUntil(merge(actions$.ofType(updateOperationalStatusActions.NOUPDATE_ON_CHANGE), actions$.ofType(StompActionskeys.DISCONNECTED)));
    });
};
//# sourceMappingURL=operationalSubscription.js.map